import { SingleChoiceStandardSettings } from 'apps/studio/components/settings/fields/SingleChoice/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import {
  ChoicesPanel,
  ChoicesSettings,
} from 'apps/studio/components/settings/fields/Base/choices'
import { SingleChoiceBoxesChoicesSettings } from 'apps/studio/components/settings/fields/SingleChoice/choices'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/Base/advanced'

export const SingleChoiceRadioSettings = [
  FieldSettingsPanel(SingleChoiceStandardSettings),
  DesignSettingsPanel,
  ChoicesPanel(),
  // ConditionsPanel,
  AdvancedPanel,
]

export const SingleChoiceBoxesSettings = [
  FieldSettingsPanel(SingleChoiceStandardSettings),
  DesignSettingsPanel,
  ChoicesPanel([
    ...SingleChoiceBoxesChoicesSettings,
    ...ChoicesSettings,
  ]),
  // ConditionsPanel,
  AdvancedPanel,
]
